<template>
<div>
    <Breadcrumbs main="Admin"  title="Info-graphics" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Info-graphics</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">

                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="info_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(first_image)="row">
                                       <div v-if="row.item.first_image">
                                        <img :src="host+row.item.first_image" alt="" style="width: 120px; height: 80px;">
                                       </div>
                                       <div v-else>
                                            N/A
                                       </div>
                                        
                                    </template>
                                    <template #cell(sec_image)="row">
                                       <div v-if="row.item.sec_image">
                                        <img :src="host+row.item.sec_image" alt="" style="width: 120px; height: 80px;">
                                       </div>
                                       <div v-else>
                                            N/A
                                       </div>
                                    </template>


                                    <template #cell(title)="row">
                                       <div v-if="row.item.title">
                                            <p>{{ row.item.title }}</p>
                                       </div>
                                    </template>
                                   
                                   

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">

                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteinfo(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editinfo(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Infography Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add info-graphics" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">

     
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter info title" v-model="info.title">
                    </div>
                </div>
            </div>
           
           
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>First Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image1" style="width: 120px; height: 80px;" :src="show_image1">
                            <input :class="info.first_image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile1">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Second Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image2" style="width: 120px; height: 80px;" :src="show_image2">
                            <input :class="info.sec_image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile2">
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Infography Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit info-graphics" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
          
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter title" v-model="edit_info.title">
                    </div>
                </div>
            </div>
          
          
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>First Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image1" style="width: 120px; height: 80px;" :src="show_image1">
                            <input :class="edit_info.first_image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="EdituploadFile1">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Second Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image2" style="width: 120px; height: 80px;" :src="show_image2">
                            <input :class="edit_info.sec_image ? 'ml-4' : 'ml-4'" type="file" accept="image/*" @change="EdituploadFile2">
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </b-modal>
    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this info-graphics?</div>
    </b-modal>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host'
import js from '../../../auth/js';
import loader from '../loader/loader.vue'
export default {
    components: {
        Datepicker,
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
              
               
           
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'first_image',
                    label: 'Fisrt Image',
                    sortable: true
                },
                {
                    key: 'sec_image',
                    label: 'Second Image',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
           

            info: {
                title: '',
                first_image:null,
                sec_image:null,

            },

            edit_info: {
                id: '',
                title: '',
                first_image:null,
                sec_image:null,

            },
            show_image1: null,
            show_image2: null,

            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],

        
        };
    },

    computed: {
        ...mapState({
            info_list: state => state.infography.infoGraphy,
            loading: state => state.infography.infoGraphyLoading,
            error: state => state.infography.infoGraphyError,

        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
            });
        },

    },

    mounted() {
        this.$store.dispatch("infography/fetchInfoGraphyList").then(() => {
            this.items = this.info_list
            this.totalRows = this.items.length;
        });

    },

    methods: {
        uploadFile1(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image1 = e.target.result
                this.info.first_image = e.target.result;

            };
        },
        uploadFile2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image2 = e.target.result
                this.info.sec_image = e.target.result;

            };
        },

        EdituploadFile1(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image1 = e.target.result
                this.edit_info.first_image = e.target.result;
            };
        },
        EdituploadFile2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image2 = e.target.result
                this.edit_info.sec_image = e.target.result;
            };
        },



        
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.info.title = null
            this.info.first_image = null
            this.info.sec_image = null
            this.show_image1 = null
            this.show_image2 = null
        
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()

        },

        handleSubmit() {

            this.$store.dispatch("infography/addInfoGraphy", {
                infography: this.info
            }).then(response => {

                if (response.status == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.info.title = null
                    this.info.first_image = null
                    this.info.sec_image = null
                    this.show_image1 = null
                    this.show_image2 = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editinfo(detail) {
            this.edit_info.id = detail.id ? detail.id : null
            this.edit_info.title = detail.title ? detail.title : null
            this.show_image1 = detail.first_image ? this.host + detail.first_image : null
            this.show_image2 = detail.sec_image ? this.host + detail.sec_image : null

        },
        resetEditModal() {
            this.edit_info.title = null
            this.edit_info.first_image = null
            this.edit_info.sec_image = null
            this.show_image1 = null
            this.show_image2 = null

        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {

            this.$store.dispatch("infography/updateInfoGraphy", {
                infography_id: this.edit_info.id,
                infography: this.edit_info,

            }).then(response => {

                if (response.status == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.edit_info.title = null
                    this.edit_info.first_image = null
                    this.edit_info.sec_image = null
                    this.show_image1 = null
                    this.show_image2 = null
                

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },
        deleteinfo(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("infography/deleteInfoGraphy", {
                delete: this.delete_value
            }).then(response => {
                if (response.status == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
